import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'https://api.gammaqc.com';

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
  timeout: 30000,
});

// Simple in-memory cache
const cache = new Map();
const CACHE_TTL = 60000; // 1 minute

const TOKEN_KEY = 'fio_session';
const API_ORIGIN = new URL(API_BASE).origin;

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  // Defense-in-depth: only attach the session token when the request is
  // actually going to our own backend origin. Today every call site passes
  // a relative path resolved against baseURL, so this is a no-op in
  // practice — but it closes the gap where a future caller reuses this
  // shared axios instance with an absolute URL to a different host and
  // silently ships the token there.
  if (token && new URL(config.url, config.baseURL || API_BASE).origin === API_ORIGIN) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // Don't redirect on auth check failures — let AuthContext handle it
    }
    return Promise.reject(err);
  }
);

export const cachedGet = async (url, ttl = CACHE_TTL) => {
  const key = url;
  const entry = cache.get(key);
  if (entry && Date.now() - entry.ts < ttl) return entry.data;
  const res = await api.get(url);
  cache.set(key, { data: res, ts: Date.now() });
  return res;
};

export const clearCache = (prefix) => {
  if (!prefix) { cache.clear(); return; }
  for (const key of cache.keys()) {
    if (key.startsWith(prefix)) cache.delete(key);
  }
};

export default api;
